var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-detail-container"},[(_vm.productVariantData)?_c('router-view',{attrs:{"productVariantData":_vm.productVariantData,"productVariantId":_vm.productVariantId}}):_vm._e(),_c('div',{staticClass:"minmaxCon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }